import React from 'react'
import { Form } from 'react-bootstrap'
import { ListingColumn } from './Listing'

const itemRender = <T,>(
	item: T,
	others: {
		hasSelectedActions: boolean | undefined
		columns: ListingColumn<T>[]
		getIDFunc: (item: T) => string
		selectFilter: string[]
		setSelect: (id: string, checked: boolean) => void
	}
) => (
	<>
		{others.hasSelectedActions && (
			<td>
				<div className="center-flex">
					<Form.Control
						style={{ boxShadow: 'none', width: '16px', height: '16px', appearance: 'revert' }}
						onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
							others.setSelect(event.target.value, event.target.checked)
						}}
						type="checkbox"
						id={`select_${others.getIDFunc(item)}`}
						name={`select_${others.getIDFunc(item)}`}
						checked={others.selectFilter.find((select) => select === others.getIDFunc(item)) !== undefined}
						value={others.getIDFunc(item)}
					/>
				</div>
			</td>
		)}
		{others.columns.map((column) => (
			<td
				key={`${others.getIDFunc(item)}_${column.headerText}`}
				colSpan={column.colSpan ? column.colSpan(item) : undefined}
				hidden={column.hidden ? column.hidden(item) : undefined}
			>
				{column.render(item)}
			</td>
		))}
	</>
)

export default itemRender
